import axios from 'axios';
import Cookies from 'js-cookie';

const standard = axios.create({
  baseURL: import.meta.env.VUE_APP_API_HOST,
  timeout: 100000,
  transformResponse: [
    function (data) {
      return data;
    },
  ],
});

if (Cookies.get('auth_greennCourse')) {
  standard.defaults.headers.common['Authorization'] = Cookies.get('auth_greennCourse');
}

// Playwright captcha bypass: send token from sessionStorage as 'datadog' header
standard.interceptors.request.use((config) => {
  try {
    const captchaToken = sessionStorage.getItem('CAPTCHA_DISABLED_TOKEN');
    if (captchaToken) {
      config.headers['datadog'] = captchaToken;
    }
  } catch { /* sessionStorage not available */ }
  return config;
});

export default standard;
